<!--
 * @Author: Merlin
 * @Date: 2024-06-06 10:15:55
 * @LastEditors: Merlin
 * @LastEditTime: 2024-10-29 14:50:35
 * @Description: 
-->

<template>
    <ModalTitle
        container-class="w-[690px] "
        :backdrop="true"
        :model-value="props.modelValue"
        @update:model-value="fnModalValueChanged"
    >
        <!-- max-w-[95vw] 不能定最大高度，应设最小高度  -->
        <template #header>
            <h1 class="" style="line-height: 40px;"> 
                {{ $t('waves.calc_roiTitle') }} 
            </h1>
        </template>
        <!-- ↑标题 --> 
        <!-- ↓主体 --> 
        <section class="mainbox body"> 
            <div class="body__inner">
                <div class="rio"
                    :style="{
                        '--main-color': oColorInfo[oForm.positionType]?.color, 
                        transform: 'scale(1.0)',
                    }"
                >
                    <div class="rio__panels-wrap">
                        <div class="rio__left-panel pr-[5px]"> 
                            <div class="setting-panel">
                                <div class="drop-container">
                                    <div class="dropdown dropdown_lg dropdown_bottomLeft balance-wrapper balance-wrapper--modal"
                                        @click="()=> isMenuShowing=true"
                                    >
                                        <WavesCoinMenu
                                            v-model="isMenuShowing" 
                                            v-model:calculatorPair="sActivePair" 
                                            :offset="[0, 18]"
                                        />
                                        <!-- ↑菜单 --> 
                                        <CurrentCoin
                                            size="24px"
                                            :name="sCoinName.toLocaleLowerCase()" 
                                        />
                                        <span style="margin: 0 4px 0 8px;"> 
                                            {{ sCoinName }}
                                        </span>
                                        <IconSvgUse
                                            use="icon-arrow-down"
                                            class="arrow"
                                            size="15px" 
                                            :style="{transform: `rotate(${ !!0 ? 180 : 0 }deg)`}"
                                        />
                                    </div>
                                    <!-- 左右分界 -->
                                    <!-- ↓ 刷新价格按钮 -->
                                    <span class="icon icon-update"
                                        style="color: rgb(147, 172, 211); --33e241ff: 24px; --13ece182: none; --a76da840: contain;"
                                    >
                                        <IconSvgUse
                                            use="live-refresh"
                                            size="22px"
                                            @click="updatePrice"
                                        />
                                    </span>
                                </div>
                                <!--
                                    ↑ 选择币种
                                    ↓ 表单部分开始
                                -->
                                <!-- ◆ ↓入场金额 --> 
                                <div class="input input_lg input_animated" style="--1e92a94a: 51.43px;">
                                    <InputBoxAmount
                                        class=""
                                        mode="multiple"
                                        prefix="$"
                                        :disabled="!!0"
                                        :tailLong="[2, oPairConfig?.precision || 2]"
                                        v-model="oForm.entryPrice"
                                        :label="$t('waves.calc_EntryPrice')"
                                    />
                                </div>
                                <!-- ◆ -->
                                <WagerSetter
                                    v-model="oForm.wager"
                                    :external="true"
                                    :externalMulti="oForm.multiplier"
                                    :externalPair="sActivePair"
                                    :externalType="oForm.feeType"
                                />
                                <!-- ◆ -->
                                <RangeBar
                                    v-model="oForm.multiplier"
                                    :showBust="true"
                                    :bustPrice="fBustPrice"
                                />
                                <!-- ◆ -->
                                <div class="tabs">
                                    <div class="tabs tabs_md tab--up">
                                        <button type="button" 
                                            class="tab tab_md"
                                            :class="{tab_active: isLong}"
                                            @click="fnSetMode(oLongShort.long)"
                                        >
                                            <IconSvgUse size="16px" use="double-arrow-up" />
                                            <span class="tab__label">
                                                {{ $t('waves.calc_Up').toUpperCase() }}
                                            </span >
                                        </button>
                                        <button type="button"
                                            class="tab tab_md"
                                            :class="{tab_active: !isLong}"
                                            @click="fnSetMode(oLongShort.short)" 
                                        >
                                            <IconSvgUse size="16px" use="double-arrow-down" />
                                            <span class="tab__label">
                                                {{ $t('waves.calc_Down').toUpperCase() }}
                                            </span >
                                        </button>
                                    </div>
                                </div>
                                <!-- ◆ -->
                                <FeeTypeRadio 
                                    mark="calculator"
                                    v-model="oForm.feeType" 
                                    :totalPosition="fPositionAmount_ye" 
                                    :coeff="fFlatCoeff" 
                                    :pair="sActivePair"
                                ></FeeTypeRadio>
                                <!-- ◆ -->
                                <div class="input input_lg input_animated" style="--1e92a94a: 51.43px;"> 
                                    <InputBoxAmount
                                        class=""
                                        mode="multiple"
                                        :disabled="!!0"
                                        :tailLong="[0, 2]"
                                        v-model="oForm.exitPrice"
                                        :label="$t('waves.calc_ExitPriceOptional')"
                                    />
                                </div>
                            </div>
                            <div class="rio__total-description description--desktop">
                                <p> {{ $t('waves.calc_desc01') }} </p>
                                <!-- ↓ 在原版被停用  --> 
                                <!-- <p> {{ $t('waves.calc_desc02') }} </p> -->
                            </div>
                        </div>
                        <!-- 
                            左右分界
                            ================================================================== 
                            左右分界
                            TODO 右侧绿色显示不稳定 
                        -->
                        <div class="rio__right-panel">
                            <div class="table">
                                <div class="table__header">
                                    <div class="table__header-item column">
                                        {{ $t('waves.calc_PriceMove').toUpperCase() }}
                                    </div>
                                    <div class="table__header-item column">
                                        {{ $t('waves.calc_ExitPrice').toUpperCase() }}
                                    </div>
                                    <div class="table__header-item column">
                                        {{ $t('waves.calc_PL_ROI').toUpperCase() }}
                                    </div>
                                </div>
                                <div class="table__body"
                                    ref="tableBody"
                                >
                                    <!-- ↓开始遍历行 -->
                                    <dl class="table__item"
                                        v-for="(cur, idx) of aRows4Tr"
                                        :key="idx"
                                        :class="{
                                            'table__item--up': cur.pnl > 0,
                                            'table__item--down': cur.pnl < 0,
                                        }"
                                    >
                                        <div class="column">
                                            <span class="price-move">
                                                {{ cur.priceMove }}%
                                            </span>
                                        </div>
                                        <div class="column">
                                            <span class="currency value">
                                                <span style="font-size: 12px;">
                                                    <span class="balance">
                                                        {{ number2LocaleString(cur.exitPrice, oPairConfig?.precision) }}
                                                    </span>
                                                </span>
                                            </span>
                                        </div>
                                        <div class="column">
                                            <span class="currency value">
                                                <span>
                                                    <div class="currency__balance-block">
                                                        <div class="currency__balances" style="font-size: 12px;">
                                                            <span class="balance">
                                                                <!-- $380.00 -->
                                                                {{ '$' + Number(cur.pnl.toFixed(2)).toLocaleString() }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </span>
                                            </span>
                                            <span class="roi">
                                                <!-- 38% -->
                                                {{ cur.roi }}%
                                            </span>
                                        </div>
                                    </dl>
                                </div>
                            </div>
                        </div>
                        <!-- ↓ 移动端可见元素  -->
                        <div class="rio__total-description description--mobile">
                            <p> {{ $t('waves.calc_desc01') }} </p>
                            <!-- <p> {{ $t('waves.calc_desc02') }} </p> -->
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </ModalTitle>
</template>


<script lang="ts" setup>
import WavesCoinMenu from "./wavesCoinMenu.vue";
import WagerSetter from './wagerSetter.vue'; 
import RangeBar from './rangeBar.vue'; 
import FeeTypeRadio from './feeTypeRadio.vue'; 
// --- ↑ 一些 vue 组件 --------------------------------- 
import {
    oLongShort,
    oPnlFlat,
    aPriceMoveStandard,
    oColorInfo,
} from '../ts/wavesData';
import { 
    fnGetLiquidationPrice_yO,
    fnCalcBust02,
    fnGetAssumedExitPrice_ae,
    fnGetPriceMoveRate4Coeff,
    fnGetCoeff,
    getAfterPnlNetProfit,
    fnGetRoi_na,
} from '../ts/wavesFn'; 
import {
    oWavesBetForm_a,
    chartState_r,
    settingsState_f, // 提取查询到的配置对象 
} from '../ts/wavesControlCenter'; 

const props = defineProps({
    modelValue: {
        type: Boolean, // 管控窗口可见性 
        default: false,
    },
});

const emits = defineEmits(['update:modelValue']); 
const route = useRoute();
const sCoinOfRoute = route.params.id; // 默认值 
const sActivePair = ref(`${sCoinOfRoute}_USDT`); // 
const isMenuShowing = ref(false); 
const tableBody = ref(null); // DOM 
const oForm = reactive({
    wager: 1_000, 
    multiplier: 1, 
    entryPrice: 0, 
    exitPrice: '', 
    feeType: oWavesBetForm_a.feeType, // // 计算器窗口打开时，将外部面板值赋值到此 
    positionType: oLongShort.long, // 开窗时默认为 long 
});

console.log("窗口打开，提取游戏面板模式 =>", oWavesBetForm_a.feeType); 

// ======= ↑ 一般声明 ============================================================
// ======= ↓ 计算值 ============================================================== 


const isLong = computed(() => {
    return (
        oForm.positionType === oLongShort.long
    );
});

const sCoinName = computed(()=>{
    const sResult = sActivePair.value.split('_')[0];
    return sResult || ''; 
});


// ↓ 当前币的信息：涨跌状态、金额 
const oPairState = computed(()=>{
    if (!chartState_r.currentPairsPrices) { 
        return;
    }
    const obj = chartState_r.currentPairsPrices[
        sActivePair.value
    ];
    return obj;
});

// ↓ 当前币的配置信息 obj
const oPairConfig = computed(()=>{
    if (!settingsState_f.pairsSettings) {
        // 在查询结束前将通过判断执行至此 
        return;
    }
    const obj = settingsState_f.pairsSettings[
        sActivePair.value
    ];
    return obj;
});

// ↓ 在 flat 模式专用 coeff 值 
const fFlatCoeff = computed(() => {
    const sType = `${oForm.feeType}Fee`; 
    const fResultCoeff = fnGetCoeff({
        amount: fPositionAmount_ye.value, // 杠杆后总仓值 
        coeffRates: oPairConfig.value?.[sType], 
        // currency: '', // 使用默认值（当前付款币种） 
    });
    console.log("fFlatCoeff 💥", fResultCoeff); 
    return fResultCoeff;
});


// ↓ 爆仓点位的数值 
const fBustPrice = computed(()=>{
    if (!oPairConfig.value){
        return 0; 
    }
    const oParams = {
        positionType: oForm.positionType, // long, short 类型
        entryPrice: Number(oForm.entryPrice), // 1号值：入场价格 
        multi: Number(oForm.multiplier), // 3号值：支付杠杆倍数 
        bustBuffer: oPairConfig.value.bustBuffer, // 配置.bustBuffer 
        bufferMultiplier: oPairConfig.value.bufferMultiplier // 配置.bufferMultiplier  
    };
    const fBust01 = fnGetLiquidationPrice_yO(oParams); 
    const fBust02 = Number(
        fnCalcBust02(fBust01, oPairConfig.value.precision)
    ); 
    return fBust02;
});


// ↓ 表格行的原始列表 
const aPriceMoveFullList_Ae = computed(()=> {
    // 原始判断目标为 “M”， 此 M 初始为 ref(0) 且 0=long, 1=short 
    const aResult = (
        isLong.value
        ? aPriceMoveStandard
        : aPriceMoveStandard.slice(2) // 抛弃头部的 0，1 
    );
    return aResult;
});


// ↓ Price move 列的值，此项在设定了出场价格时会用到 
const fPriceMove_ze = computed(()=> {
    const step01 = (
        (
            Number(oForm.exitPrice) // 出场
            / Number(oForm.entryPrice) // 入场
            - 1
        )
        * 100
    );
    const fResult = Math.abs(step01);
    return fResult;
});


// ↓ 返回一个数组
// ↓ 数组的每个成员将转换为表格的一个行 
const aPriceMoveFinalList_We = computed(()=>{
    // 在入场价格： ze.value 
    // 1,2,3 : 800, 350, 200
    const aResult = (
        oForm.exitPrice
        ? [fPriceMove_ze.value]
        : aPriceMoveFullList_Ae.value
    );
    return aResult;
});

// ↓ 总仓值 
const fPositionAmount_ye = computed(()=>{
    const wager = Number(oForm.wager);
    const multi = Number(oForm.multiplier);
    return wager * multi;
});


// ↓ 表格行数据 
const aRows4Tr = computed(()=>{
    const wager = Number(oForm.wager);
    const entryPrice = Number(oForm.entryPrice);
    const exitPrice = Number(oForm.exitPrice);
    const bCompare = (
        isLong.value
        ? exitPrice <= Number(fBustPrice.value) // “出” 场价格 <= 爆仓价格 
        : exitPrice >= Number(fBustPrice.value)
    );
    const fnToGetCoeff_l = (priceMove) => {
        const priceMoveRate = fnGetPriceMoveRate4Coeff({
            entryPrice,
            exitPrice: exitPrice || fnGetAssumedExitPrice_ae({ 
                priceMove: Math.abs(priceMove),
                entryPrice,
            }),
        });
        const oParams = {
            amount: fPositionAmount_ye.value, // 杠杆后总仓值 
            coeffRates: oPairConfig.value?.[`${oForm.feeType}Fee`], // pnlFee, flatFee, 
            priceMove: priceMoveRate,
            // currency: '', // 使用默认值（当前付款币种） 
        };
        const fResultCoeff = fnGetCoeff(oParams);
        return fResultCoeff;
    };
    const fnGetPnl_m = (priceMove) => {
        const oParams = {
            entryPrice,
            exitPrice: exitPrice || fnGetAssumedExitPrice_ae({ 
                priceMove,
                entryPrice,
            }),
            wager,
            position: fPositionAmount_ye.value,
            positionType: oForm.positionType,
            feeType: oForm.feeType, // pnl, flat 
            coeff: fnToGetCoeff_l(priceMove),
        };
        const pnl = getAfterPnlNetProfit(oParams);
        const result = (
            exitPrice && bCompare
            ? wager * -1
            : pnl
        );
        return result;
    };
    const fnGetRoi_T = (priceMove) => {
        const result = fnGetRoi_na({
            pnl: fnGetPnl_m(priceMove),
            wager,
        });
        return result;
    };
    // ↓ 最终结果 
    const TheResult = aPriceMoveFinalList_We.value.reduce((aResult, priceMove) => {
        // console.log("priceMove=", priceMove); 
        const oThisOne = {
            priceMove: Number(priceMove.toFixed(2)),
            exitPrice: exitPrice || fnGetAssumedExitPrice_ae({
                priceMove,
                entryPrice,
            }),
            pnl: Number(fnGetPnl_m(priceMove)),
            roi: getFixed(fnGetRoi_T(priceMove), 2), // 不宜使用 Number.toFixed() 防止把金额上进，
        };
        // console.log(`priceMove=${priceMove}, pnl=`, oThisOne.pnl); 
        const arr = [ ...aResult, oThisOne ];
        return arr;
    }, []);
    return TheResult;
});


// ↓ 监听输入，触发右侧表格滚动条移动  
watch(
    fPositionAmount_ye,
    ()=>{
        moveToCenter();
    },
);

// ↓ 监听币种变化 
watch(
    sActivePair,
    (sNewPair)=>{
        console.log("当前币种💰=>", sNewPair);
        updatePrice(); 
        moveToCenter(); 
    },
    {immediate: true},
);

// ↓ 监听窗口打开
watch(
    () => props.modelValue,
    () => {
        console.log("计算器窗口可性：", props.modelValue); 
        nextTick().then(()=>{
            moveToCenter();
        });
        // updatePrice();
    },
    {immediate: true},
);

// ↓ 更新价格 
function updatePrice(){
    const fPrice = oPairState.value?.value || 0;
    // console.log("当前币种价格：", fPrice); 
    oForm.entryPrice = fPrice;
    moveToCenter(); 
}

// ↓ 执行窗口的开关 
function fnModalValueChanged(newVal){
    emits('update:modelValue', !!newVal);
}

// ↓ 设定Mode 
function fnSetMode(sNewMode:oLongShort){
    oForm.positionType = sNewMode;
    moveToCenter(); 
}

// ↓ 移动表格滚动条 
function moveToCenter(){
    const tableDom = tableBody.value;
    if (!tableDom) return; 
    const {scrollHeight, offsetHeight} = tableDom;
    // console.log("tableBody", tableDom, scrollHeight); 
    const iScrollTo = (scrollHeight - offsetHeight) * 0.45;
    tableDom.scroll(0, iScrollTo);
}

</script>


<style scoped lang="scss">
// ↓ 自制类名 
.mainbox{
    // height: 690px;
    // max-height: calc(100vh - 64px - 73px - 100px);
    max-height: calc(100vh - 80px - 100px); 
    // overflow-x: hidden;
    overflow-y: auto;
    // margin-inline: -24px;
    // padding: 0 24px;
}

// ==========================================

.table__body {
    overflow-y: auto;
    scrollbar-color: var(--color_grey-60) rgba(13,19,28,.8);
    scrollbar-width: thin;
    color: white; // 补
    scroll-behavior: smooth;
}


.table__body::-webkit-scrollbar,
.table__body::-webkit-scrollbar-track {
    background-color: #0d131ccc;
    border-radius: 2px
}

.table__body::-webkit-scrollbar {
    height: 4px;
    width: 4px
}

.table__body::-webkit-scrollbar-thumb {
    background-color: var(--color_grey-60);
    border-radius: 2px
}

.table__header {
    align-items: center;
    display: flex;
    height: 28px;
    justify-content: space-between;
    padding: 0 16px
}

.table__header-item {
    color: var(--color_dark-shades-gray-40);
    font-size: 11px;
    font-weight: 700;
    letter-spacing: .06em;
    line-height: 16px;
    margin-bottom: 6px;
    text-transform: uppercase
}

.table__header-item:first-child {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}

.table__header-item:last-child {
    text-transform: none
}

.table__body {
    display: flex;
    flex-direction: column;
    gap: 6px;
    // margin-right: -5px;
    margin-right: 0; // 改 
    max-height: 600px;
    padding-right: 5px;
}


@media (max-width: 768px) {
    .table__body {
        max-height:none;
        overflow-y: unset
    }
}

.table__item {
    align-items: center;
    background: #161f2ccc;
    border-radius: 8px;
    display: flex;
    font-size: 16px;
    height: 50px;
    justify-content: space-between;
    line-height: 20px;
    padding: 14px 16px
}

.table__item,
.table__item .price-move {
    font-weight: 600;
    letter-spacing: -.02em;
    margin-bottom: 0;
    margin-top: 0
}

.table__item .price-move {
    font-size: 12px;
    line-height: 16px
}

.table__item .roi {
    color: #ffffff80;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: -.02em;
    line-height: 14px;
    margin-bottom: 0;
    margin-top: 0
}

.table__item--up {
    color: var(--color_green)
}

.table__item--up .roi {
    color: #1bb83d8a;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: -.02em;
    line-height: 14px;
    margin-bottom: 0;
    margin-top: 0
}

.table__item--down {
    color: var(--color_red)
}

.table__item--down .roi {
    color: #ed1d498a;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: -.02em;
    line-height: 14px;
    margin-bottom: 0;
    margin-top: 0
}

.table .column:first-child {
    width: 24%
}

.table .column:nth-child(2),
.table .column:nth-child(3) {
    width: 28%
}

.table .column:nth-child(4) {
    width: 20%
}

@media (max-width: 768px) {
    .table .column {
        width:33.3333333333%
    }
}

.rio__title {
    font-size: 24px;
    font-weight: 700;
    letter-spacing: -.02em;
    line-height: 32px;
    margin-bottom: 16px;
    margin-top: 0
}

.rio__panels-wrap {
    display: flex;
    gap: 16px
}

@media (max-width: 768px) {
    .rio__panels-wrap {
        flex-direction:column
    }
}

.rio__left-panel {
    min-width: 250px;
    width: 250px
}

@media (max-width: 768px) {
    .rio__left-panel {
        width:100%
    }
}

.rio__right-panel {
    width: 100%;
    & > .table { // 补
        width: 100%;
        height: 100%; 
    }
}



.rio__total-description {
    color: var(--color_grey-40);
    font-size: 11px;
    font-weight: 600;
    letter-spacing: -.02em;
    line-height: 14px;
    margin-bottom: 0;
    margin-top: 14px;
}

// ↓ 关闭 
// .rio__total-description p:not(:first-child):last-child {
//     margin-bottom: 53px !important;
// }

.rio .description--mobile {
    display: none;
    margin-top: 0
}

// .rio .rio__total-description p:not(:first-child):last-child {
.rio .rio__total-description p + p {
    margin-top: 16px;
}

@media (max-width: 768px) {
    .rio .description--desktop {
        display:none
    }
    .rio .description--mobile {
        display: block
    }
}

.setting-panel {
    align-items: center;
    -webkit-backdrop-filter: blur(9.5px);
    backdrop-filter: blur(9.5px);
    background: var(--dark-shades-background-80,#161f2c);
    border: 1px solid #161f2c;
    border-radius: 14px;
    display: flex;
    flex-direction: column;
    gap: 14px;
    padding: 12px;
    // ↓后补 
    & > * {
        // box-shadow: 0px 0px 0px 1px #666 inset; 
        min-height: 20px; 
        width: 100%;
    }
}

@media (max-width: 768px) {
    .setting-panel {
        background:none;
        border: none;
        padding: 0
    }
}


.setting-panel .icon-update {
    cursor: pointer
}

.setting-panel .fees-block {
    display: flex;
    flex-direction: column;
    min-width: 100%
}

.setting-panel .tabs {
    display: flex;
    width: 100%; 
}

.setting-panel .tabs .tab_active {
    background-color: var(--main-color);
}

.icon-arrow {
    height: 22px!important;
    margin-left: 2px!important;
    width: 22px!important
}

.icon-arrow svg {
    height: 100%!important;
    width: 100%!important
}

.dropdown_opened .dropdown__trigger-custom .btn-drop > .icon-arrow {
    color: var(--color_grey-40);
    transform: rotate(180deg);
    transition: transform .15s linear
}

.drop-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    .dropdown_bottomLeft{
        display: flex;
        align-items: center;
        color: white;
        cursor: pointer;
    }
}


.drop-container .btn-drop {
    align-items: center;
    display: flex;
    height: 32px;
    justify-content: center
}

.drop-container .btn-drop span {
    margin: 0 4px 0 8px
}

.footer__btns {
    display: flex;
    gap: 12px
}

.footer__btn {
    width: 50%
}

</style>


<style lang="scss" scoped>

.tabs {
    align-items: stretch;
    background: #37465c4d;
    border-radius: 10px;
    display: inline-flex;
    overflow-x: auto;
    // ↓后补
    button svg{
        color: white;
        opacity: 0.7;
        margin-right: 5px;
    }
}

.tabs_fullwidth {
    width: 100%
}

.tabs_sm.tabs {
    padding: 6px
}

.tabs_md.tabs {
    padding: 4px
}

.tabs_lg.tabs {
    padding: 6px
}

.tab {
    align-items: center;
    border-radius: 8px;
    display: flex;
    flex: 1 1;
    justify-content: center;
    margin-right: 4px;
    padding-left: 24px;
    padding-right: 24px;
    transition: background-color .1s ease-in-out
}

.tab:last-child {
    margin-right: 0
}

.tab__icon {
    color: var(--color_grey-20);
    fill: var(--color_grey-20);
    margin-left: -8px;
    margin-right: 8px;
    transition: color .1s ease-in-out,fill .1s ease-in-out
}

.tab__label {
    color: var(--color_grey-40);
    font-weight: 600;
    letter-spacing: -.28px;
    margin: 0;
    text-align: center;
    transition: color .1s ease-in-out;
    white-space: nowrap
}

.tab__badge {
    background-color: var(--color_blue);
    border-radius: 6px;
    color: var(--color_white);
    display: block;
    font-size: 10px;
    font-weight: 700;
    line-height: 14px;
    margin-left: 8px;
    margin-right: -8px;
    padding: 2px 6px;
    transition: color .1s ease-in-out,background-color .1s ease-in-out;
    white-space: nowrap
}

.tab:hover:not(.tab_active):not(.tab_disabled) {
    background-color: #93acd317
}

.tab:hover:not(.tab_active):not(.tab_disabled) .tab__icon {
    color: var(--color_white);
    fill: var(--color_white)
}

.tab:hover:not(.tab_active):not(.tab_disabled) .tab__label {
    color: var(--color_white)
}

.tab_active {
    background-color: var(--color_blue)
}

.tab_active .tab__icon {
    fill: var(--color_white)
}

.tab_active .tab__icon,.tab_active .tab__label {
    color: var(--color_white)
}

.tab_active .tab__badge {
    background-color: var(--color_white);
    color: var(--color_blue)
}

.tab:disabled {
    cursor: default
}

.tab_disabled {
    cursor: not-allowed !important; 
}

.tab_sm.tab {
    height: 25px
}

.tab_sm :where(.tab__icon) {
    height: 20px;
    width: 20px
}

.tab_sm :where(.tab__icon) svg {
    height: 100%;
    width: 100%
}

.tab_sm .tab__label {
    font-size: 12px;
    line-height: 16px
}

.tab_md.tab {
    height: 36px;
}

.tab_md :where(.tab__icon) {
    height: 20px;
    width: 20px
}

.tab_md :where(.tab__icon) svg {
    height: 100%;
    width: 100%
}

.tab_md .tab__label {
    font-size: 12px;
    line-height: 16px
}

.tab_lg.tab {
    height: 40px
}

.tab_lg :where(.tab__icon) {
    height: 24px;
    width: 24px
}

.tab_lg :where(.tab__icon) svg {
    height: 100%;
    width: 100%
}

.tab_lg .tab__label {
    font-size: 14px;
    line-height: 18px
}

.tab_sm {
    padding: 4px 12px
}
</style>
